import {actionMap} from '../reducers/index'
import * as types from './types'

export default (params) => dispatch => {
    dispatch({type: types.RESET_WEATHER})
}

export const handler_RESET_WEATHER = (reduxState) => {
    return ({
        ...reduxState,
        isLoading: false,
        data: undefined
    })
}

actionMap[types.RESET_WEATHER] = handler_RESET_WEATHER



// WEBPACK FOOTER //
// ./src/screens/weather/actions/resetWeather.js